import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="bc-header bc-sticky">
      <div className="header-container">
        <div className="bc-header-brand">
          <Link className="bc-link" to="/">
            <span className="bc-icon bc-lg">bancolombia-horizontal</span>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
